/*
 * @Descripttion:
 * @Author: olei<wangzheng_jzb@100tal.com>
 * @Date: 2022-05-16 16:09:05
 * @LastEditors: olei<wangzheng_jzb@100tal.com>
 * @LastEditTime: 2022-05-17 18:24:13
 */
import React from 'react';

import CommonItem from "./CommonListItem";

import { Checkbox } from 'antd';

class UserAddBetterList extends React.Component<any, any> {
    vBase: number;
    mainBox: any;
    dom: any;
    io: any;
    constructor(props: any) {
        super(props);
        this.state = {
            isShow: !this.props.isBetter,
        };
        // 50 * 8
        this.vBase = 16;
    }

    componentDidMount() {
        this.mainBox = document.querySelector('#userListComponent');
        this.dom = document.querySelector(`.user-${this.props.user.id}`);
        this.props.isBetter && this.setObserver();
    }

    componentWillUnmount() {
        this.setState = () => {}; // 预防 Can't perform a React state update on an unmounted component
        this.io && this.io.disconnect();
    }

    setObserver() {
        // observer

        if ('IntersectionObserver' in window && this.dom) {
            this.io = new IntersectionObserver(
                (entries) => {
                    const [data] = entries;
                    // showIndex 禁止块外声明常量活变量
                    this.checkImIntersection(data.isIntersecting);
                },
                {
                    root: this.mainBox,
                    rootMargin: `${this.vBase}px 0px ${this.vBase}px`,
                }
            );
            this.io.observe(this.dom);
        }
    }
    checkImIntersection(isIntersecting: boolean) {
        const { isShow } = this.state;
        // if (!isIntersecting && this.mainBox) {
        //     // 可视区高度（含缓冲区）
        //     const h = this.mainBox.offsetHeight + this.vBase * 2;
        //     // 可视区域起始位（含缓冲区）
        //     const s = this.mainBox.scrollTop - this.vBase;
        //     // 可是区域结束位（含缓冲区）
        //     const e = s + h;
        //     isIntersecting = this.dom.offsetTop < e && this.dom.offsetTop > s;
        // }
        if (isShow !== isIntersecting) {
            this.setState({
                isShow: isIntersecting,
            });
        }
    }
    render() {
        const { user, onChooseOrgUser, disabled } = this.props;
        const { isShow } = this.state;
        return (
            <div className={`user-${user.id} orgUserListCheck`} key={user.id}>
              {isShow && <Checkbox
                value={user.id}
                onChange={onChooseOrgUser}
                disabled={disabled}
              >
                <CommonItem {...{ type: "orgMember", item: user }} />
              </Checkbox>}
            </div>
        );
    }
}

export default UserAddBetterList;
